/**
 * Nsection B6 Service
 * B.6.避免重複計量 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b6';

export interface SubParagraphItem {
  content: string;
}

export interface DoubleCountingItem {
  paragraph: string;
  sub_paragraphs: SubParagraphItem[];
}

export interface NsectionB6Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  double_counting_avoidance: DoubleCountingItem[] | null;
  nsection_b6_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB6Update {
  double_counting_avoidance?: DoubleCountingItem[];
}

const nsectionB6Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB6Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB6Update): Promise<NsectionB6Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB6Service;
